<template>
<div class="ui middle aligned center aligned grid loadmore">
  <div class="column padzero">
    
    <div class="ui pointing below medium label" :class="{'grey': isBusy, 'green': !isError && !isBusy , 'red':isError}">
      <i class="icon" :class="{'hourglass half': isBusy, 'file text outline': !isError && !isBusy, 'warning sign': isError && !isBusy }"></i>
<div v-if="isBusy">Loading ...&nbsp &nbsp &nbsp</div>
      <div v-if="!isError && !isBusy">Showing {{count}} of {{totalCount}} {{type}}</div>
      <div v-if="isError && !isBusy">Server or network error</div>
      <a class="detail" v-if="isError && !isBusy" @click="onRetry()">Retry</a>
      <a class="detail" v-if="count < totalCount && !isError && !isBusy" @click="onViewMore()">View More</a>
    </div>
<div class="ui centered inline loader" :class="{'active': isBusy}"></div>
</div>
</template>

<script>
'use strict';
export default {
name: 'loadmore',
props: {
  type: {
    type: String,
    default: 'items'
  },
  isBusy: {
    type: Boolean,
    default: false,
      },
  isError: {
    type: Boolean,
    default: false
      },
  count: {
    type: Number,
    default: 0
  },
  totalCount: {
    type: Number,
    default: 0
  },
  onRetry: {
    type: Function,
    required: true
  },
  onViewMore: {
    type: Function,
    required: true
  }
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loadmore {
  margin-top:.3em !important;
}
div {display: inline}

</style>



// WEBPACK FOOTER //
// Loadmore.vue?7bd98c5d